import { render } from "./OverviewBasketMiniStepComponent.vue?vue&type=template&id=574c7633&ts=true"
import script from "./OverViewBasketMiniStepComponent?vue&type=script&lang=ts"
export * from "./OverViewBasketMiniStepComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__